import React, { Component } from "react";
import { BrowserRouter, Route } from 'react-router-dom'
import Nav from './navbar';
import Home from "./home";
import About from "./about";
import Contact from "./contact";
import "./App.css";

class App extends Component {

  

  render() {
    return (
      <BrowserRouter>
          <div id="main">
          <Nav />
            <Route exact path='/' component={Home} />
            <Route path='/about' component={About} />
            <Route path='/contact' component={Contact} />
          </div>
        
      </BrowserRouter>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js